import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';
import { CourseData } from './CourseData';
import { exampleData } from './helper/course-data';
import { useCourseData } from './helper/useCourseData';

const CourseDataDisplay = () => {
	const courseData = useCourseData();
	const addDevTools = typeof process.env?.NODE_ENV !== 'undefined'
		&& process.env?.NODE_ENV === 'development'
		&& window.location.hostname.includes('localhost');

	return (
		<div className='display-container' style={{ margin: 'auto', maxWidth: '1440px' }}>
			{addDevTools && <CourseInfoHelper />}
			<CourseData courseInfo={courseData} />
		</div>
	);
}

const CourseInfoHelper = () => {
	const types = Object.keys(exampleData);
	const [type, setType] = useState(localStorage.getItem('course-info-type') ?? '');

	return <>
		<Box sx={{ py: 2 }}>
			<FormControl variant='standard' size='small'>
				<InputLabel id='course-info-type-select'>Type</InputLabel>
				<Select
					labelId='course-info-type-select-label'
					id='course-info-type-select'
					value={type}
					label='Type'
					onChange={(e) => {
						setType(e.target.value);
						localStorage.setItem('course-info-type', e.target.value);
						window.location.reload();
					}}
					displayEmpty
					variant={'standard'}
					sx={{ minWidth: '15rem' }}
				>
					<MenuItem value={'bilbao-data'}>bilbao-data (only works in local ilias instance)</MenuItem>
					{types.map((type, index) => (<MenuItem key={index} value={type}>{type}</MenuItem>))}
				</Select>
			</FormControl>
		</Box>
	</>;
};

export default CourseDataDisplay;
